/// <reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../models/meevo.model.custom.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="./collection.model.ts"/>
///<reference path="./filter.model.ts"/>
///<reference path="custom-validation.model.ts"/>

module Meevo.Components.Controls.SmartMover {

    //#regionConsts
    export const ON_FETCH_START: string = 'ON_FETCH_START';
    export const ON_FETCH_END: string = 'ON_FETCH_END';
    export const ON_FILTER_CHANGED: string = 'ON_FILTER_CHANGED';
    export const ON_HIDE_MOVER_CHANGED: string = 'ON_HIDE_MOVER_CHANGED';
    export const SHOW_MOVER: string = 'SHOW_MOVER';
    export const MODEL_UPDATED_OUTSIDE: string = 'MODEL_UPDATED_OUTSIDE';
    export const MAX_SELECTED_TAXES = 5;
    //#endregionConsts

    //#regionInterfaces


    import Dictionary = _.Dictionary;
    import MeevoEventEmitter = Meevo.Components.Common.MeevoEventEmitter;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export interface IEntityModel extends ICategoryEntity {
        readonly idAttribute: IdType;
    }

    export interface IComponentBindings {
        blockOnFetch?: boolean;
        required?: boolean;
        genericArrayList?: IListElement[];
        criteria: Dictionary<any>;
        properties: string[];
        model: Dictionary<any>;
        template: DataTemplateNames;
        securityAccess?: SecurityAccessEnum;
        defaultValue: Dictionary<any>;
    }

    export interface ISmartMoverCriteria extends IDataTemplateCriteria {

    }

    export interface IMeevoSmartMover extends IComponentBindings, ng.IComponentController {
        allSelectedInternal: boolean;
        criteria: ISmartMoverCriteria;
    }

    export interface ISecureDataTemplate extends IDataTemplate {
        readonly securityFailed: boolean;

        securityAccess: SecurityAccessEnum;
        securityErrorMessage: string;
        allSelectedSecurityKey: SecurityKeys;
        getSecurityErrorMessage($translate: ng.translate.ITranslateService, data: Dictionary<any>): string;
        checkSecurityKey(securityService: Meevo.Components.Common.ISecurityService): void;
    }

    export interface IDataTemplate extends MeevoEventEmitter {
        readonly valid: boolean;
        readonly totalSelectedCount: number;
        readonly totalParentSelectedCount: number;
        readonly hasSecurity: boolean;
        readonly validation: ICustomValidation[];

        hideAllSelectedCheckbox?: boolean;
        showAllSelected: boolean;
        showMover: boolean;
        voidIfAllSelected: boolean;
        allSelected?: boolean;
        collection: ICollectionBase<any> | IApiCollection<any>;
        leafCollection: ICollectionBase<any> | IApiCollection<any>;
        tips?: string[];

        totalSelectedMessage?: string;
        totalSelectedMessageModel?: ISmartMoverTextBase;
        totalParentSelectedMessage?: string;
        totalParentSelectedMessageModel?: ISmartMoverTextBase;
        title?: string;
        disabled?: boolean;
        allSelectedLabel: string;
        showDescription: boolean;
        description?: string;
        reconnectLeafCollectionModel(model);

        fetch(dataService: Meevo.Components.BaseClasses.IDataService): ng.IPromise<any> | void;
        setWatchers(scope: ng.IScope): void;
        onCriteriaUpdate(newCriteria: Dictionary<any>, $q: ng.IQService): ng.IPromise<any>;
        onDestroy(): void;
        setEvents(onFilterChanged: TFilterChangedFn): void;
        onHideToggle(hidden: boolean): void;
        updateCollectionFromModel();
        updateConnectedModels(): void;

        onChangeCallback?(): Function;
        model: Dictionary<any>
        required?: boolean;
    }

    export interface IDataTemplateCriteria {
        [key: string]: any;
        selectModelBy(): Function | null;
    }

    export interface IDataTemplateOptions {
        criteria: IDataTemplateCriteria;
        loggedInUserId: string;
        required: boolean;
        modalService: Meevo.Components.Modal.IModalService;
        $scope: ng.IScope;
        $filter: ng.IFilterService;
        defaultValue?: Dictionary<any>;
        inactiveLabel?: string;
        dataService: Meevo.Components.BaseClasses.IDataService
        url?: string;
        hiddenValue?: SmartMoverHiddenValue;
        $q: ng.IQService;
        defaultFilterValue: any;
        alwaysExcludeInactive?: boolean;
        labelKeys?: IMoverLabelKeys;
    }

    export type IDataTemplateStatic = new(model: Dictionary<any>, properties: string[], options?: IDataTemplateOptions, items?: IListElement[]) => IDataTemplate;

    export interface IListElement {
        objectState?: ObjectStateEnum;
        displayName?: string;
        [index: string]: any;
    }

    export interface ISelectable {
        selected: boolean;
    }


    export interface ICategoryEntity extends ISelectable, IListElement {
        objectState: ObjectStateEnum;
        name: string;
        idKey: string;
    }

    export interface IMoverLabelKeys {
        title?: string;
        allSelectedLabel?: string;
        totalSelectedMessage?: string;
        validationMessage?: string;
        filterLabel?: string;
    }

    //#endregionInterfaces

    //#regionTypes

    export type DataTemplateNames =
        | 'reportStudentsAndTeachers'
        | 'reportEmployeeWithCategories'
        | 'reportEmployee'
        | 'reportEmployeeCategories'
        | 'reportEmployeesNonUsers'
        | 'reportManufacturers'
        | 'reportDistributorPurchaseOrder'
        | 'reportDistributor'
        | 'Liabilities'
        | 'reportPointPromotions'
        | 'reportDistributorInventoryReturn'
        | 'reportReferralTypes'
        | 'reportDrawers'
        | 'reportUsers'
        | 'reportUsersNonEmployees'
        | 'reportProductCategories'
        | 'reportServiceCategories'
        | 'reportPaymentTypes'
        | 'reportPayrollEmployee'
        | 'reportDP005ProductCategories'
        | 'reportDP005ProductManufacturers'
        | 'reportServicesWithCategories'
        | 'locationsGeneric'
        | 'reportFloorLocations'
        | 'servicesWithCategories'
        | 'memberships'
        | 'giftCardTypes'
        | 'packageTypes'
        | 'productVariants'
        | 'discountFees'
        | 'productVariantsManufacturers'
        | 'reportTaxes'
        | 'users'
        | 'employees'
        | 'textelEmployeesWithCategories'
        | 'CSEEmployeesWithCategoriesDataTemplate'
        | 'CSEProductsWithCategoriesDataTemplate'
        | 'CSEServicesWithCategoriesDataTemplate'
        | 'salesRankingEmployees'
        | 'reportCoreLocations'
        | 'reportLocationGroups'
        | 'employeesWithCategories'
        | 'resourcesWithCategories'
        | 'reportManufacturersProdCats'
        | 'reportProdCatsManufacturers'
        | 'membershipsWithTypes'
        | 'clientTypes'
        | 'distributor'
        | 'inventoryManufacturers'
        | 'inventoryDistributors'
        | 'inventoryProductCategories'
        | 'ymMemberships'
        | 'reportVisitNoteType'
        | 'purchaseOrderProductCategories'
        | 'purchaseOrderSupplyCategories'
        | 'purchaseOrderManufacturers'
        | 'productVariantsWithCategories'
        | 'productWithCategoriesAndBundles'
        | 'docsAndFormsTemplate'
        | 'reportLiabilities'
        | 'reportTeacherWithCategories'
        | 'reportStudentWithCategories'
        | 'reportEmployeeOnlyWithCategories'
        | 'alertsManagerEmployee'
        | 'alertsManagerServiceWithCategories'
        | 'alertsManagerEmployeeConfiguration'
        | 'reportEmployeeStudentTeacher'
        | 'serviceCategories'
        | 'productCategories'
        | 'reportResourcesWithCategories'
        | 'alertsManagerUser'
        | 'reportMerchantAccount'
        ;

    // names of the HTML files under the "filter-templates" folder
    export type FilterTemplateNames =
        | 'include-object-state'
        | 'active-inactive'
        | 'purchase-orders'
        | 'point-promotions'
        | 'terminated'
        ;

    export type IDataTemplates = {
        [key in DataTemplateNames]: IDataTemplateStatic;
    };

    export type IdType = number | string;
    export type ModelValueType = number | string | Dictionary<any>;
    export type CategoryCheckboxClassName = 'checked' | 'unchecked' | 'partial' | 'disabled';
    export type TFilterChangedFn = (values: any) => void;
    //#endregionTypes
}
